import React from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const configurationButtonStyle = css({
	height: '28px',
	width: '28px',
	background: token('color.background.danger'),
	color: token('color.text.danger'),
	borderRadius: token('radius.full'),
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	border: 'transparent',
	cursor: 'pointer',
	'&:focus, &:active': {
		outline: 'none',
	},
});

//eslint-disable-next-line  @atlaskit/design-system/no-html-button
export const ConfigurationButton = (props: any): React.JSX.Element => (
	<button {...props} css={configurationButtonStyle} />
);
